// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { editCardModalStyles } from "@guestsupply/Overrides/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

editCardModalStyles.editCardModal = {
    sizeVariant: "large",
};

editCardModalStyles.stateGridItem = { width: 12 };

editCardModalStyles.cityGridItem = { width: 12 };

editCardModalStyles.postalCodeGridItem = { width: 12 };

editCardModalStyles.bottomGridItem = {
    width: 12,
    css: css`
        align-items: center;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

editCardModalStyles.notifyError = {
    css: css`
        margin-bottom: 0;
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
        }
    `,
};
